"use stick";

let currentIndex = 0;
const smallImages = document.querySelectorAll('.figure__image1 img');

function switchImages() {
  // Get the next index
  const nextIndex = (currentIndex + 1) % smallImages.length;

  // Swap the src attributes of the current image and the next image
  const tempSrc = smallImages[currentIndex].src;
  smallImages[currentIndex].src = smallImages[nextIndex].src;
  smallImages[nextIndex].src = tempSrc;

  // Update the index for the next image
  currentIndex = nextIndex;
}

// Set an interval to call the function every 5 seconds
setInterval(switchImages, 5000);


//slide left
document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              entry.target.classList.add('visible');
          }
      });
  });

  document.querySelectorAll('.slide-left').forEach(element => {
      observer.observe(element);
  });
});



//Porgress bar

window.onscroll = function() {
  updateProgressBar();
};

function updateProgressBar() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const progress = (scrollTop / docHeight) * 100;

  const progressBar = document.getElementById("progress-bar");
  progressBar.style.width = progress + "%";
} 